import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  hideModalConfirmChanges,
  onClickSaveUpdateBank,
} from 'actions/setting/bankAccount';
import styles from './ConfirmChangesModal.css';

class ConfirmChangesModal extends React.Component {
  _onClickCancel = e => {
    this.props.dispatch(hideModalConfirmChanges());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickSaveBank = () => {
    const { bankAccountForm } = this.props;
    this.props.dispatch(onClickSaveUpdateBank(bankAccountForm));
  };

  render() {
    const { showModalConfirmChanges } = this.props;
    return (
      <Modal
        show={showModalConfirmChanges}
        dialogClassName={styles.modalDialog}
      >
        <Modal.Header bsClass={`modal-header ${styles.modalHeader}`}>
          Confirm Change
        </Modal.Header>
        <Modal.Body>
          Do you want to save the changes you made in "Bank Account"?
          <br />
          Your changes will be lost if you dont save them.
        </Modal.Body>
        <Modal.Footer>
          <span className="pull-right">
            <button
              className={`btn btn-default ${styles['btn-cancel']}`}
              type="button"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={this._onClickSaveBank}
            >
              Save
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const { showModalConfirmChanges } = state.setting.bankAccount;
  return {
    bankAccountForm: getFormValues('bankAccount')(state),
    showModalConfirmChanges,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmChangesModal);
